import { render, staticRenderFns } from "./styleguide.vue?vue&type=template&id=123f82c1"
import script from "./styleguide.vue?vue&type=script&lang=js"
export * from "./styleguide.vue?vue&type=script&lang=js"
import style0 from "./styleguide.vue?vue&type=style&index=0&id=123f82c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports